import React from "react";
import Input from "../shared/Input";

import PropTypes from "prop-types";

export default function SearchInput({ onInputChange, placeholder }) {
  return (
    <Input type="text" placeholder={placeholder} onChange={onInputChange} />
  );
}

SearchInput.propTypes = {
  onInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
